import type {BBox, MultiPolygon, Polygon} from "geojson";

const geomHelpers = {

        /**
         * Returns the bounding box of a polygon
         * @param polygon
         */
        bboxFromPolygon(polygon: Polygon): BBox {
            let coord1 = 99999;
            let coord2 = 99999;
            let coord3 = -999999;
            let coord4 = -999999;

            polygon.coordinates.forEach((coordArray) => {
                coordArray.forEach((coord) => {
                    coord1 = Math.min(coord1, coord[0]);
                    coord2 = Math.min(coord2, coord[1]);
                    coord3 = Math.max(coord3, coord[0]);
                    coord4 = Math.max(coord4, coord[1]);
                });
            });
            return [coord1, coord2, coord3, coord4];
        },

        bboxFromMultiPolygon(multiPolygon: MultiPolygon): BBox {
            let coord1 = 99999;
            let coord2 = 99999;
            let coord3 = -999999;
            let coord4 = -999999;

            multiPolygon.coordinates.forEach((coordArrayArray) => {
                coordArrayArray.forEach((coordArray) => {
                    coordArray.forEach((coord) => {
                        coord1 = Math.min(coord1, coord[0]);
                        coord2 = Math.min(coord2, coord[1]);
                        coord3 = Math.max(coord3, coord[0]);
                        coord4 = Math.max(coord4, coord[1]);
                    });
                });
            });
            return [coord1, coord2, coord3, coord4];
        }
    }
;

export default geomHelpers;
